<template>
    <div class="col cols">
        <!-- <h1>ID{{ loadItem.module_id }} -- Name {{ loadItem.module_name }} -- Chat-User-ID {{ loadItem.user_id }} -- Type {{ type }} </h1> -->
        <div class="col-message">
            <div class="chat-wrapper" ref="container">
                <div class=" dashboard_chat h-auto" id="container">
                    <ul ref="scrollToMe">
                        <template v-for="item in items" :key="item.id">
                            <template v-if="item.msg_handler=='sender'">
                                <li class="sent">
                                    <div class="chat_img">
                                        <img :src="(item.profile_img)" :alt="(item.name)">
                                    </div>
                                    <div class="chat_message">
                                        <h4 v-html="item.name"></h4>
                                        <h5 class="mb-2" v-html="item.time_ago"></h5>
                                        <div class="message_text">
                                            <div v-html="item.message"></div>
                                            <small v-show="(item.attachment)"><a v-bind:href="item.attachment" class="blue_color"><span class="material-icons-outlined blue_color">attachment</span> Attachment</a></small>
                                        </div>
                                    </div>
                                </li>
                            </template>
                             <template v-if="item.msg_handler=='receiver'">
                                <li class="recive">
                                    <div class="chat_img">
                                       <img :src="(item.profile_img)" :alt="(item.name)">
                                    </div>
                                    <div class="chat_message">
                                        <h4 v-html="item.name"></h4>
                                        <h5 v-html="item.time_ago"></h5>
                                        <div class="message_text">
                                            <div v-html="item.message"></div>
                                            <small v-show="(item.attachment)"><a v-bind:href="item.attachment" class="blue_color"><span class="material-icons-outlined blue_color">attachment</span> Attachment</a></small>
                                        </div>
                                    </div>
                                </li>
                             </template>
                        </template>
                    </ul>
                </div>
            </div>
            <div class="send_message_form" v-if="needSend">
                <div  class="mt-5 w-100 d-flex justity-content-end">
                    <input type="text" name="" class="form-control w-100" placeholder="Your message here ..." v-model="messageToSend"  v-on:keyup.enter="sendMessage">
                    &nbsp;&nbsp;&nbsp;
                    <a href="#" v-on:click="sendMessage" class="btn btn-secondary">Send</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    name: "Messeges",
    data() {
      return {
        items: [],
        messageToSend: "",
        showLoader: Function, 
      };
    },

    props: {
        loadItem: Object,
        type: Number,
        token: String,
        needSend: Boolean,
    },

    watch: { 
        
        loadItem () { 

            this.loadMessages();

        }
    },

    updated() {
        this.scrollToEnd();
    },

    methods: {

        scrollToEnd() {

            /*
             * Scroll the DIV to End
             */
 
            const container = this.$refs.container;
            container.scrollTop = container.scrollHeight;

        },

        loadMessages() {

            /* 
            * Call related method according to the User Type 
            */
            switch ( this.type ) {
                case 4: 
                {
                    this.getMessages( "customer/support/messages" );
                    break;
                }
                case 3: 
                {
                    this.getMessages( "supplier/support/messages" );
                    break;
                }
            }

        },
        getMessages ( apiURL ) {
 
           
            const headers = { 
                Authorization: "Bearer " + this.token
            };

            let form = {
                module_name: this.loadItem.module_name,
                module_id: this.loadItem.module_id,
                module_link: this.loadItem.module_link,
                chat_user_id: this.loadItem.user_id,
            }

            this.showLoader();

            axios.post ( process.env.VUE_APP_API_URL + apiURL, form, { headers } )
            .then (( res ) => {

                this.showLoader();

                /* Success returned by API */
                if ( res.data.status ) {

                    /* We found Data */
                    let data = res.data.data;
                    this.items = data;


                } else {

                    this.$toast.show("Something went wrong!", {
                        type: "error",
                        dismissible: true,
                        position: 'top',
                        duration:3500,
                        pauseOnHover: true,  
                    });

                    let message = res.data.message;
                    let error = res.data.errors;

                    

                    console.error ( `Err-Message: ${ message }` );
                    console.error( `Err-Details: ${ JSON.stringify( error ) }` );

                }


            })
            .catch ((error) => {


                this.showLoader();

                console.error( "There was an error!", error);
                this.$toast.show( "API Error!", {
                    type: "error",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                });

                console.error( error );

            });

        },

        sendMessage () {
           

            // alert("sendMessage");
            let apiURL = ( this.type == 4 ) ? "customer/support/message/sent":"supplier/support/message/sent";

            const headers = { 
                Authorization: "Bearer " + this.token
            };

            // console.log( `Loaded Item: ${ JSON.stringify( this.loadItem ) }`)
            let form = {
                module_name: this.loadItem.module_name,
                module_id: this.loadItem.module_id,
                chat_user_id: this.loadItem.user_id,
                message: this.messageToSend,
            }

            this.showLoader();
            axios.post ( process.env.VUE_APP_API_URL + apiURL, form, { headers } )
            .then (( res ) => {

                this.showLoader();

                /* Success returned by API */
                if ( res.data.status ) {

                    this.loadMessages();
                    this.messageToSend = "";
                    // var dashboard_chat = $('.chat-panel.'+handler).find('.dashboard_chat');
                    // elm.scrollTop(dashboard_chat.height());

                } else {

                    this.$toast.show("Something went wrong!", {
                        type: "error",
                        dismissible: true,
                        position: 'top',
                        duration:3500,
                        pauseOnHover: true,  
                    });

                    let message = res.data.message;
                    let error = res.data.errors;

                    console.error ( `Err-Message: ${ message }` );
                    console.error( `Err-Details: ${ JSON.stringify( error ) }` );

                }


            })
            .catch ((error) => {

                this.showLoader();
                console.error( "There was an error!", error);
                this.$toast.show( "API Error!", {
                    type: "error",
                    dismissible: true,
                    position: 'top',
                    duration:3500,
                    pauseOnHover: true,  
                });

                console.error( error );

            });

        },

        submitForm() {

            // alert( " submitForm " );
            let apiURL = process.env.VUE_APP_API_URL + ( this.type == 4 ) ? "customer/support/message/sent":"supplier/support/message/sent";

            // const headers = { 
            //     Authorization: "Bearer " + this.token
            // };

            // let myHeaders = {
            //     Accept: "application/json",
            //     Authorization: "Bearer "+ this.token
            // };

            let myHeaders = new Headers();
                myHeaders.append("Accept", "application/json");
                myHeaders.append("Authorization", "Bearer "+ this.token);
            

            let formdata = new FormData();
                formdata.append("module_name", this.loadItem.module_name);
                formdata.append("module_id", this.loadItem.module_id);
                formdata.append("chat_user_id", this.loadItem.chat_user_id);
                formdata.append("message", this.messageToSend);


            let requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
            };


            fetch( apiURL, requestOptions )
            .then( response => response.text() )
            .then( result => {
                console.log(result); 
                let resultObj = JSON.parse(result);
                if(resultObj.status){

                    this.$toast.show("Something went wrong!", {
                        type: "success",
                        dismissible: true,
                        position: 'top',
                        duration:3500,
                        pauseOnHover: true,  
                    });
                    
                }else{
                    var errors = resultObj.errors;
                    console.log(errors);

                    for (var key of Object.keys(errors)) {
                        this.message += errors[key]+"";
                    }

                }
            })
            .catch(error => console.log('error', error));
        }

    }

}
</script>
